import axios from "axios";

export const getEventSearch = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/eventsearch/" + encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editEventSearch = (data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/eventsearch/editeventsearch",
      data
    )
    .then((res) => res.data);
};
